export const getChangedKeys = <T extends object>(a: T, b: T): (keyof T)[] => {
  const allUniqueKeys = [...new Set([...Object.keys(a), ...Object.keys(b)])] as (keyof T)[];
  return allUniqueKeys.filter(key => a[key] !== b[key]);
};

export const mapValues = <T, U>(obj: Record<string, T>, fn: (value: T, key: string) => U): Record<string, U> => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    return {...acc, [key]: fn(value, key)};
  }, {});
};
